import { useEffect, useRef } from "react";
import { onChartStats } from "./renderHost";

/**
 * Render-latency readout: Net (gateway → browser), HELM (browser → CPU render completion),
 * Total (gateway → CPU render completion), p50 over the last ~2k trades. Updated through a ref at the
 * worker's 4 Hz stats cadence — never React state.
 */
export function ChartLatency(): React.JSX.Element {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(
    () =>
      onChartStats((s) => {
        const el = ref.current;
        if (!el) return;
        const f = (v: number | null): string =>
          v === null ? "—" : v < 10 ? v.toFixed(1) : String(Math.round(v));
        const L = s.latency;
        const prefix = s.renderer === "compat" ? "Compat renderer · " : "";
        el.textContent =
          prefix + `Net ${f(L.netP50)} · TradePrizm ${f(L.helmP50)} · Total ${f(L.totalP50)} ms`;
        el.title =
          `Receive-to-render completion p50/p95/p99: TradePrizm ${f(L.helmP50)}/${f(L.helmP95)}/${f(L.helmP99)} ms; ` +
          `gateway-to-render p50/p99 ${f(L.totalP50)}/${f(L.totalP99)} ms (CPU submission, not display presentation); ` +
          `${String(L.samples)} samples; clock offset ${f(L.offsetMs)} ms; md ${s.md}; ${String(s.trades)} trades`;
        el.dataset["md"] = s.md;
      }),
    [],
  );
  return (
    <span ref={ref} className="num chart-latency" title="Receive-to-render completion latency">
      Net — · TradePrizm — · Total — ms
    </span>
  );
}
